import React from "react";
import { Modal } from "react-bootstrap";
import ModalFormCategoriaProducto from "./ModalFormCategoriaProducto";

const ModalCategoriaProducto = ({ show, handleClose, categoria }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Modificar Categoría</Modal.Title>
      </Modal.Header>

      <ModalFormCategoriaProducto
        categoria={categoria}
        handleClose={handleClose}
      />
    </Modal>
  );
};

export default ModalCategoriaProducto;